export const DEFAULT_DATE_FORMAT = "dd.MM.yyyy";
export const DEFAULT_DATE_PLACEHOLDER = "dd.mm.yyyy";

export const SCHEDULE_DATE_FORMAT = "dd.MM.yyyy HH:mm";
export const SCHEDULE_TIME_FORMAT = "HH:mm";
export const SCHEDULE_DATE_PLACEHOLDER = "dd.mm.yyyy --:--";

export const END_DATE_INPUT_NAME = "endDate";
